import { render, staticRenderFns } from "./LastJobs.html?vue&type=template&id=36ff2953&scoped=true&external"
import script from "./LastJobs.vue?vue&type=script&lang=js"
export * from "./LastJobs.vue?vue&type=script&lang=js"
import style0 from "./LastJobs.scss?vue&type=style&index=0&id=36ff2953&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ff2953",
  null
  
)

export default component.exports